import React from "react";
import classnames from "classnames";
import { useUser } from "~/context/userContext";
import { User } from "~/generated/rtk-query/nowdo-live-api.generated";
import Link from "next/link";

type ProfileButtonProps = {
  profile: User & { fullName: string; isAdult: boolean };
  loading: boolean;
  onFollowClick: () => unknown;
  onUnfollowClick: () => unknown;
  className?: string;
  target?: React.ComponentProps<"a">["target"];
};
export const ProfileButton: React.FC<ProfileButtonProps> = ({
  profile,
  onFollowClick,
  onUnfollowClick,
  loading,
  className,
  target = "_blank",
}) => {
  const { user } = useUser();
  const isMe = user?.id === profile.id;

  if (isMe) {
    return (
      <Link
        href="/profile_settings"
        type="button"
        target={target}
        className={classnames(["_button", "primary", "basic", className])}
      >
        <i className={classnames(["_only__pc"])}>プロフィール</i>
        設定
      </Link>
    );
  }
  if (profile.isFollowed) {
    return (
      <button
        type="button"
        className={classnames([
          "_button",
          "primary",
          "basic",
          className,
          {
            loading,
          },
        ])}
        onClick={onUnfollowClick}
      >
        フォロー中
        <div className="_loader">Loading...</div>
      </button>
    );
  }

  return (
    <button
      type="button"
      className={classnames([
        "_button",
        "primary",
        className,
        {
          loading,
        },
      ])}
      onClick={onFollowClick}
    >
      フォロー
      <div className="_loader">Loading...</div>
    </button>
  );
};
